import BaseModelAPI from '../BaseModelAPI';

export default class DirectorateList extends BaseModelAPI {

	static entity = 'directoratelist'
	static entityName = 'directorate';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
